import { render, staticRenderFns } from "./IndicateursSinistres.vue?vue&type=template&id=286d7c1c&"
import script from "./IndicateursSinistres.vue?vue&type=script&lang=js&"
export * from "./IndicateursSinistres.vue?vue&type=script&lang=js&"
import style0 from "./IndicateursSinistres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports